// extracted by mini-css-extract-plugin
export default {"titleCell":"H8cwn","authorsCell":"zeSGF","authors":"eCdHY","authorTrigger":"ZRYkA","statusCell":"vd2L0","preview":"KWMga","title":"y1giz","subtitle":"ppYeK","schoolCell":"Bfdga"};